import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../components/Toast';
import { jsonDeleteResponse, jsonPost } from '../api/jsonRequest';
import { queryKeys } from '../query/queryKeys';
import { buildPollUrl } from '../query/queryParams';
import { usePollQuery } from '../query/usePollQuery';

export function useCompanyMessages({ companyId, enabled = true, pauseRefetch = false }) {
    const url = buildPollUrl('/api/Message/GetAllMessagesForCompany', companyId);

    return usePollQuery({
        queryKey: queryKeys.messages.company(companyId),
        url,
        enabled,
        pauseRefetch,
    });
}

export function useUserMessages({ userOrCompanyId, enabled = true, pauseRefetch = false }) {
    const url = buildPollUrl('/api/Message/GetAllMessagesForUser', userOrCompanyId);

    return usePollQuery({
        queryKey: queryKeys.messages.user(userOrCompanyId),
        url,
        enabled,
        pauseRefetch,
    });
}

export function useDeleteMessage() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id }) => {
            const res = await jsonDeleteResponse(`/api/Message/DeleteMessage/${id}`);
            if (res.status !== 200) {
                throw new Error('Creation failed');
            }
            return res.data;
        },
        onSuccess: () => {
            Toast.fire({
                title: 'Deleted',
                icon: 'success',
            });
            void queryClient.invalidateQueries({ queryKey: queryKeys.messages.all() });
        },
        onError: () => {
            Toast.fire({
                title: 'Creation failed',
                icon: 'error',
            });
        },
    });
}

export function useUpdateCustomerStatus() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ payload }) => {
            const res = await jsonPost('api/Message/UpdateMessage', payload);
            if (res.status !== 200) {
                throw new Error('Customer status not updated');
            }
            return res.data;
        },
        onSuccess: (_data, variables) => {
            variables.handleClose1?.();
            variables.handleClose2?.();
            if (variables.one != null) {
                Toast.fire({
                    icon: 'success',
                    title: 'Customer Status Updated.',
                });
            } else if (variables.two != null) {
                Toast.fire({
                    icon: 'success',
                    title: 'Reply to Customer Sent.',
                });
            }
            void queryClient.invalidateQueries({ queryKey: queryKeys.messages.all() });
        },
        onError: () => {
            Toast.fire({
                icon: 'error',
                title: 'Customer status not updated, please try again.',
            });
        },
    });
}

export function useRequestProcessor() {
    return useMutation({
        mutationFn: async ({ payload, ModalToggle }) => {
            const res = await jsonPost('api/Message/CreateMessage', payload);
            if (res.status !== 200) {
                throw new Error('Message not sent');
            }
            return ModalToggle;
        },
        onSuccess: (ModalToggle) => {
            ModalToggle?.();
            Toast.fire({
                icon: 'success',
                title: 'Processor Reqest Sent.',
            });
        },
        onError: () => {
            Toast.fire({
                icon: 'error',
                title: 'Message not sent, please try again.',
            });
        },
    });
}
